import { getMonth, getYear } from 'date-fns'
import { range } from 'lodash'
import React from 'react'
import ReactDatePicker from 'react-datepicker'
import { ReactComponent as CalendarIcon } from '../../../../../assets/icons/calendar-vet-alt.svg'
import * as S from './styles'

const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
]

const maxYear = getYear(new Date()) + 1

const YEARS = range(2015, maxYear, 1)

const DatePicker = ({ label, showIcon, invertIcon = false, width, height, showYearDropdown = false, showMonthDropdown = false, hideCurrentMonth = false, errorMessage, ...rest }) => {
  const hasError = !!errorMessage

  const handleChangeRaw = (e) => {
    const date = e.currentTarget.value
    const isBackspace = e.nativeEvent.inputType === 'deleteContentBackward' || e.nativeEvent.inputType === 'deleteContentForward'
    if (!date || isBackspace) return
    const maskedDate = (date.match(/^\d{2}$/) !== null) ? date + '/' : (date.match(/^\d{2}\/\d{2}$/) !== null) ? date + '/' : date
    if (maskedDate.length > 10) {
      e.preventDefault()
      return
    }
    e.currentTarget.value = maskedDate
  }

  const renderCustomDatePickerHeader = (date, changeMonth, changeYear) => {
    return <S.DateHeader>
      <S.SelectWrapper>
        <S.Select
          value={MONTHS[getMonth(date)]}
          onChange={({ target: { value } }) =>
            changeMonth(MONTHS.indexOf(value))
          }
          minWidth='110px'
        >
          {MONTHS.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </S.Select>
      </S.SelectWrapper>
      <S.SelectWrapper>
        <S.Select
          value={getYear(date)}
          onChange={({ target: { value } }) => changeYear(value)}
          minWidth='69px'
        >
          {YEARS.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </S.Select>
      </S.SelectWrapper>
    </S.DateHeader>
  }

  return (
    <S.DatePickerContainer showIcon={showIcon} width={width} height={height} invertIcon={invertIcon} hasError={hasError}>
      {label && <S.Label>{label}</S.Label>}
      {showIcon && <S.Icon><CalendarIcon /></S.Icon>}
      {hasError && (<S.ErrorMessage>{errorMessage}</S.ErrorMessage>)}
      <ReactDatePicker
        showYearDropdown={showYearDropdown}
        showMonthDropdown={showMonthDropdown}
        hideCurrentMonth={hideCurrentMonth}
        renderCustomHeader={({
          date,
          changeMonth,
          changeYear
        }) => renderCustomDatePickerHeader(date, changeMonth, changeYear)}
        onChangeRaw={(e) => handleChangeRaw(e)}
        {...rest}
      />
    </S.DatePickerContainer>
  )
}

export default DatePicker
